import React from 'react';
import { Skeleton } from '@execonline-inc/execonline-ui';
import * as style from './style.module.css';

const CalendarSkeleton: React.FC = () => (
  <div className={style.calendar}>
    {/* Month navigation */}
    <div className="mb-4 flex items-center justify-center gap-6">
      <Skeleton variant="circle" size="sm" />
      <Skeleton variant="text" size="md" style={{ width: '120px' }} />
      <Skeleton variant="circle" size="sm" />
    </div>

    {/* Day headers */}
    <div className="mb-2 grid grid-cols-7 gap-1">
      {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((_, index) => (
        <div key={index} className="text-center">
          <Skeleton variant="text" size="sm" style={{ width: '30px', margin: '0 auto' }} />
        </div>
      ))}
    </div>

    {/* Calendar days grid */}
    <div className="grid grid-cols-7 gap-2">
      {[...Array(35)].map((_, index) => (
        <div key={index} className="aspect-square">
          <Skeleton variant="box" size="md" style={{ width: '100%', height: '32px' }} />
        </div>
      ))}
    </div>
  </div>
);

export default CalendarSkeleton;
